export function changeOpenid (val) {
    return { type: 'new', val }
}